import React, { FCC } from 'react';
import { ICheckboxLabelProps } from './types';

/**
 * Helper to set Bootstrap classes for groupped checkboxes
 */
export const CheckboxLabel: FCC<ICheckboxLabelProps> = (props) => {
  if (props.inline) {
    return <label className={'checkbox-inline'}>{props.children}</label>;
  }
  return (
    <div className={'checkbox'}>
      <label>{props.children}</label>
    </div>
  );
};

export default CheckboxLabel;
